//memberservice
export const apiGetListJoinRequest = `Member/GetListJoinRequest`
export const apiApproveJoinAssociationRequest = `Member/ApproveJoinAssociationRequest`
export const apiRejectJoinAssociationRequest = `Member/RejectJoinAssociationRequest`
export const apiGetMemberDetail = `Member/GetMemberDetail`
export const apiCreatIndividual = `Member/CreateIndividual`
export const apiCreateOrganization = `Member/CreateOrganization`
export const apiGetListMember = `Member/GetListMember`
export const apiDeleteMember = `Member/Delete`
export const apiDeleteUserAssociation = `Member/DeleteUserAssociation`
export const apiRegisterIndividual = `Member/RegisterIndividual`
export const apiRegisterOrganization = `Member/RegisterOrganization`
export const apiGetLisTLogUserAssociation = `Member/GetLisTLogUserAssociation`
export const apiLeaveRequest = `Member/LeaveRequest`
export const apiCancelLeaveRequest = `Member/CancelLeaveRequest`
export const apiGetAllMemberForCategory = `Member/GetAllMemberForCategory`
export const apiGetMemberDetailToUpgrade = `Member/GetMemberDetailToUpgrade`
export const apiUpdateMemberDetailToUpgrade = `Member/UpdateMemberDetailToUpgrade`
export const apiUploadMembershipUpgradeForm = `Member/UploadMembershipUpgradeForm`
export const apiJoinAssociationRequest = `Member/JoinAssociationRequest`

export const apiAssignRole = `Member/AssignRole`
